<script setup lang="ts">
import { ref } from 'vue';
import { Field, useForm } from 'vee-validate';

const { handleSubmit } = useForm();
const runValidations = handleSubmit(() => true);

const props = withDefaults(defineProps<{
  firstName: string,
  lastName: string,
  prePopulate?: boolean,
  customLabel?: string
}>(), {
  customLabel: 'Applicant or Authorized Representative'
});

interface EmitInterface {
  (event: 'signatureValid', value: string): void
}

const emits = defineEmits<EmitInterface>();

const verificationFirstName = ref(props.prePopulate ? props.firstName : '');
const verificationLastName = ref(props.prePopulate ? props.lastName : '');

defineExpose({
  handleSubmit: runValidations
});

const emitChange = async (): Promise<void> => {
  const localValid = await runValidations();
  if (localValid) {
    emits('signatureValid', `${verificationFirstName.value} ${verificationLastName.value}`);
  }
};
</script>
<template>
  <div class="text-blue-900 text-lg">
    <p>Please complete the electronic signature below to confirm the legal agreements and the accuracy of the information you have provided.</p>
    <small class="mb-5">Note: Once you’ve signed your application, you will need to contact us regarding any further changes.</small>
    <div class="border mt-5">
      <p class="bg-gray-100 px-5 py-3">Electronic Signature of {{ customLabel }}</p>
      <p class="px-5 py-3 mb-3">Enter first and last name: <strong>{{ firstName }} {{ lastName }}</strong></p>
      <div>
        <div class="form-inline mb-2 px-5">
          <div>
            <Field v-model="verificationFirstName" :validate-on-blur="false" validate :validate-on-model-update="false" @blur="emitChange" type="text" v-slot="{ field, errorMessage, meta }" name="verificationFirstName" :rules="{required: true, confirmed_insensitive: firstName }">
              <input placeholder="First Name" v-autofocus="true" v-bind="field" v-capitalized="field" :class="{ ...meta }" class="left">
              <span class="error"><span v-if="!meta.valid">{{ errorMessage }}</span></span>
            </Field>
          </div>
          <div>
            <Field v-model="verificationLastName" :validate-on-blur="false" validate :validate-on-model-update="false" @blur="emitChange" type="text" v-slot="{ field, errorMessage, meta }" name="verificationLastName" :rules="{ required: true, confirmed_insensitive: lastName }">
              <input placeholder="Last Name" v-bind="field" v-capitalized="field" :class="{ ...meta }" class="right">
              <span class="error"><span v-if="!meta.valid">{{ errorMessage }}</span></span>
            </Field>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
